import { ApplicationConfig, provideBrowserGlobalErrorListeners, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideToastr } from 'ngx-toastr';
import { provideEnvironmentNgxMask } from 'ngx-mask'
import { NgxSpinnerModule } from 'ngx-spinner';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha-2';
import { 
  provideNgxWebstorage,
  withLocalStorage,
  withSessionStorage,
  withNgxWebstorageConfig
 } from 'ngx-webstorage';
import { routes } from './app.routes';
import { environment } from '../environments/environment.prod';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideNgxWebstorage(withLocalStorage(), withSessionStorage()),
    provideToastr(),
    provideEnvironmentNgxMask(),
    provideAnimations(),
    importProvidersFrom(NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })),
    //{
    //  provide: RECAPTCHA_SETTINGS,
    //  useValue: {
    //    siteKey: environment.recaptcha.siteKey,
    //  } as RecaptchaSettings,
    //},
  ]
};
